import React from "react";
import Cookies from "js-cookie";
import GoogleAnalytics from "react-ga";

GoogleAnalytics.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS);

export const trackPage = (page) => {
  GoogleAnalytics.set({ page });
  let abValue = Cookies.get("ab_kit");
  if (abValue !== "undefined") {
    GoogleAnalytics.set({ dimension2: abValue });
  }
  GoogleAnalytics.pageview(page);
};

export class Container extends React.Component {
  componentDidMount() {
    // eslint-disable-next-line
    const page = this.props.location.pathname;
    trackPage(page);
  }

  componentDidUpdate(prevProps) {
    const currentPage = prevProps.location.pathname;
    const nextPage = this.props.location.pathname;

    if (currentPage !== nextPage) {
      trackPage(nextPage);
    }
  }

  render() {
    return (
      <div className="col-xs-12">
        <div className="form col-lg-6 col-lg-offset-3 col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2 col-xs-12">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Container;
